import * as angular from "angular";
import {IController} from "angular";
import {LogisticsVehicleStatusType} from "../../types/logistics-vehicle-status.type";

export class LogisticsVehicleStatusSelectListComponent implements IController {

  logisticsVehicleStatus: any;
  ngPlaceholder: any;
  onChange: Function;

  private statuses: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.statuses = Object.values(LogisticsVehicleStatusType);
  }

}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleStatusSelectList', {
    bindings: {
      logisticsVehicleStatus: '<',
      onChange: '&'
    },
    template: require('./logistics-vehicle-status-select-list.html').default,
    controller: LogisticsVehicleStatusSelectListComponent
  });
